import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ToDo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.777 1.245C15.777.558 16.334 0 17.02 0h23.234a1.245 1.245 0 0 1 0 2.49H17.021a1.245 1.245 0 0 1-1.244-1.245ZM7.894 9.547a4.15 4.15 0 0 0 4.149-4.15 4.15 4.15 0 1 0-4.15 4.15Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 22a5.395 5.395 0 0 1 5.394-5.396A5.395 5.395 0 0 1 13.287 22a5.395 5.395 0 0 1-5.393 5.396A5.395 5.395 0 0 1 2.5 22Zm5.394-2.906a2.905 2.905 0 1 0 .001 5.81 2.905 2.905 0 0 0-.001-5.81ZM2.5 38.604a5.395 5.395 0 0 1 5.394-5.396 5.395 5.395 0 0 1 5.393 5.396A5.395 5.395 0 0 1 7.894 44 5.395 5.395 0 0 1 2.5 38.604Zm5.394-2.906a2.905 2.905 0 1 0 .001 5.81 2.905 2.905 0 0 0-.001-5.81Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.777 17.85c0-.689.557-1.246 1.244-1.246h23.234a1.245 1.245 0 0 1 0 2.49H17.021a1.245 1.245 0 0 1-1.244-1.245ZM17.021 33.208a1.245 1.245 0 0 0 0 2.49h23.234a1.245 1.245 0 0 0 0-2.49H17.021ZM17.021 23.245a1.245 1.245 0 0 0 0 2.49h13.277a1.245 1.245 0 0 0 0-2.49H17.02ZM15.777 41.094c0-.687.557-1.245 1.244-1.245h13.277a1.245 1.245 0 0 1 0 2.49H17.02a1.245 1.245 0 0 1-1.244-1.245ZM17.021 6.642a1.245 1.245 0 0 0 0 2.49h13.277a1.245 1.245 0 0 0 0-2.49H17.02Z"
  }));
});
ToDo.displayName = 'ToDo';
ToDo.defaultProps = {
  'aria-label': 'ToDo'
};
export default ToDo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ToDo.js
// module id = 3307
// module chunks = 11